module.exports = __webpack_public_path__ + "static/img/shaoma.cf63eab.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/img/newCode/qrCode/shaoma.png
// module id = 1082
// module chunks = 2